import { IOption, TOptionValue } from '@cian/ui-kit';

export class SelectOption<Value extends TOptionValue> implements IOption<Value> {
  public readonly label: IOption<Value>['label'];

  public readonly value: Value;

  public constructor(label: SelectOption<Value>['label'], value: SelectOption<Value>['value']) {
    this.label = label;
    this.value = value;
  }
}

export type SelectOptionsCollection<Value extends TOptionValue> = Array<SelectOption<Value>>;
